import React, {useState, useEffect} from 'react'
import { currentIntervalTime } from 'utils'

const useCurrentIntervalTime = () => {

  const [currentInterval, setCurrentInterval] = useState(currentIntervalTime())
  const updateCurrentInterval = () => setCurrentInterval(currentIntervalTime())

  useEffect(() => {
    const _timer = setInterval(updateCurrentInterval, 1000 * 60 * 5)
    return () => _timer && clearInterval(_timer)
  }, [])


  return currentInterval
}

export default useCurrentIntervalTime